function IconFlight(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			{...props}
			className="flip-if-rlt"
		>
			<path
				d="M2.4806 7.86272L1.99603 6.16675H2.08317L2.93317 7.30008L3.08317 7.50008H3.33317H6.99984L7.67993 7.50008L7.47708 6.85094L6.01326 2.16675H6.38938L9.57584 7.26508L9.72271 7.50008H9.99984H13.6665C13.9437 7.50008 14.1665 7.72289 14.1665 8.00008C14.1665 8.27727 13.9437 8.50008 13.6665 8.50008H9.99984H9.72271L9.57584 8.73508L6.38938 13.8334H6.01326L7.47708 9.14922L7.67993 8.50008H6.99984H3.33317H3.08317L2.93317 8.70008L2.08317 9.83341H1.99603L2.4806 8.13744L2.51985 8.00008L2.4806 7.86272Z"
				fill="black"
				stroke="black"
			/>
		</svg>
	);
}

export default IconFlight;
